import { render, staticRenderFns } from "./modelsGallery.vue?vue&type=template&id=5a3e3572&scoped=true"
import script from "./modelsGallery.vue?vue&type=script&lang=js"
export * from "./modelsGallery.vue?vue&type=script&lang=js"
import style0 from "./modelsGallery.vue?vue&type=style&index=0&id=5a3e3572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e3572",
  null
  
)

export default component.exports